import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";

import { InspectionDetailStaticInfoViewModel } from "src/app/models/inspection-detail-view-models.models";
import { Inspection } from "src/app/models/inspection.model";
import { InspectionDetailsViewModelService } from "src/app/services/inspection-details-view-model.service";
import { InspectionService } from "../service/inspection.service";

export interface InspectionDetailStateModel {
	staticInfo: InspectionDetailStaticInfoViewModel;
	inspection?: Inspection;
}

const inspectionStateDefaults: InspectionDetailStateModel = {
	staticInfo: null,
	inspection: null,
};

export class GetInspection {
	static readonly type = "[Inspection] GetInspection";
	constructor(public payload: string, public companyId: string, public endpoint: string) {}
}

export class ClearInspection {
	static readonly type = "[Inspection] ClearInspection";
}

@Injectable()
@State<InspectionDetailStateModel>({
	name: "inspection",
	defaults: inspectionStateDefaults,
})
export class InspectionState {
	constructor(
		private inspectionService: InspectionService,
		private inspectionDetailsViewModelService: InspectionDetailsViewModelService,
	) {}

	@Selector()
	static getStaticInfo(state: InspectionDetailStateModel) {
		return state.staticInfo;
	}

	@Selector()
	static getInspection(state: InspectionDetailStateModel) {
		return state.inspection;
	}

	@Action(GetInspection)
	getInspection(
		{ patchState }: StateContext<InspectionDetailStateModel>,
		{ payload, companyId, endpoint }: GetInspection,
	) {
		return this.inspectionService.getInspection(payload, companyId, endpoint).pipe(
			tap((result: Inspection) => {
				patchState({
					staticInfo: this.inspectionDetailsViewModelService.getStaticInfo(result),
					inspection: result,
				});
			}),
		);
	}

	@Action(ClearInspection)
	clearInspection({ setState }: StateContext<InspectionDetailStateModel>) {
		return setState(inspectionStateDefaults);
	}
}
